<template>
  <div class="Inicio">
    <div class="md-layout md-alignment-center-center">
      <img src="@/assets/img/portada.svg">
    </div>
  </div>
</template>

<script>
export default {
  name: "Inicio",
  methods: {
    asignar() {
      this.pacientes = JSON.parse(localStorage.getItem("pacientes"));
      this.escuelas_citas = JSON.parse(localStorage.getItem("escuelas_citas"));
      this.escuelas_contactos = JSON.parse(
        localStorage.getItem("escuelas_contactos")
      );
      this.escuelas = JSON.parse(localStorage.getItem("escuelas"));
      this.categorias_escuelas = JSON.parse(
        localStorage.getItem("categorias_escuelas")
      );
    },
    limpiar() {
      localStorage.setItem("pacientes", JSON.stringify([]));
      localStorage.setItem("escuelas_citas", JSON.stringify([]));
      localStorage.setItem("escuelas_contactos", JSON.stringify([]));
      localStorage.setItem("escuelas", JSON.stringify([]));
      this.asignar();
    }
  },
  data() {
    return {
      escuelas: [],
      escuelas_contactos: [],
      escuelas_citas: [],
      pacientes: [],
      categorias_escuelas: []
    };
  },
  beforeCreate() {
    if (!this.$session.exists() && !this.$session.get("tipo")) {
      this.$emit("visible", false);
      this.$router.push("/login");
    } else {
      this.$emit("visible", true);
      this.$emit("classes", "container");
    }
  },
  created() {
    this.asignar();
    this.escuelas_citas = localStorage.getItem("escuelas_citas");
  }
};
</script>
